import { render, staticRenderFns } from "./AnimatorDetailDialog.vue?vue&type=template&id=8288c04e&scoped=true&"
import script from "./AnimatorDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AnimatorDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8288c04e",
  null
  
)

export default component.exports